import React, { useState } from 'react';
import { useOnboarding } from '../context/OnboardingContext';
import PageLayout from '../components/PageLayout';
import FormInput from '../components/FormInput';
import NavigationButtons from '../components/NavigationButtons';
import { normalizeHeight, validateHeight } from '../utils/signupValidation';

const OnboardingHeight = () => {
  const { formData, updateField } = useOnboarding();
  const [error, setError] = useState('');

  // Facultative, mais contrôlée : une taille saisie en mètres (« 1,65 ») partait
  // jusqu'ici en `taille: 1` et faisait échouer toute l'inscription au dernier écran.
  const handleNext = () => {
    const err = validateHeight(formData.height);
    if (err) { setError(err); return false; }
    const n = normalizeHeight(formData.height);
    updateField('height', n === null ? '' : String(n));
    return true;
  };

  return (
    <PageLayout step={2}>
      <h2 className="title">Quelle est votre taille ?</h2>
      <p className="subtitle">
        Pour connaitre votre indice corporels, cela permet de mieux comprendre
        le fonctionnement de votre corps
      </p>

      {/* `text` + `inputMode` plutôt que `number` : un champ number rend une valeur
          vide pour « 1,65 » sur certains navigateurs, au lieu de la laisser corriger. */}
      <FormInput
        type="text"
        name="height"
        inputMode="decimal"
        autoComplete="off"
        maxLength={6}
        placeholder="165"
        value={formData.height}
        error={error}
        onChange={(e) => { updateField('height', e.target.value); setError(''); }}
        unit="cm"
      />
      {error && <p className="signup-error">{error}</p>}

      <NavigationButtons
        nextPath="/onboarding/poids"
        prevPath="/onboarding/naissance"
        onNext={handleNext}
      />
    </PageLayout>
  );
};

export default OnboardingHeight;
